import React, { useRef } from 'react';

const ImageWithFallback = ({ src, alt, className }) => {
  const imgRef = useRef(null);

  const handleError = () => {
    if (imgRef.current) {
      imgRef.current.style.display = 'none';
    }
  };

  return <img ref={imgRef} src={src} alt={alt || ''} className={className} onError={handleError} />;
};

export default ImageWithFallback;